export var FirestoreWarrantyServiceCollectionsEnum;
(function (FirestoreWarrantyServiceCollectionsEnum) {
    FirestoreWarrantyServiceCollectionsEnum["REGISTERED_SERIAL_NUMBERS"] = "registered-serial-numbers";
    FirestoreWarrantyServiceCollectionsEnum["REGISTERED_USERS"] = "registered-users";
    FirestoreWarrantyServiceCollectionsEnum["ALTERNATIVE_TO_PRIMARY_EMAILS_MAP"] = "alternative-to-primary-emails";
    FirestoreWarrantyServiceCollectionsEnum["PRIMARY_TO_ALTERNATIVE_EMAILS_MAP"] = "primary-to-alternative-emails";
})(FirestoreWarrantyServiceCollectionsEnum || (FirestoreWarrantyServiceCollectionsEnum = {}));
export var ServerEndpoints;
(function (ServerEndpoints) {
    ServerEndpoints["IS_SERIAL_NUMBER_REGISTERED"] = "is-serial-number-registered";
    ServerEndpoints["REGISTER_SERIAL_NUMBER"] = "register-serial-number";
    ServerEndpoints["GET_SERIAL_NUMBER"] = "get-serial-number";
    ServerEndpoints["UPDATE_EMAIL_OF_SERIAL_NUMBER"] = "update-email-of-serial-number";
    ServerEndpoints["REMOVE_SERIAL_NUMBER"] = "remove-serial-number";
    ServerEndpoints["GET_USER_BY_EMAIL"] = "get-user-by-email";
    ServerEndpoints["REGISTER_USER"] = "register-user";
    ServerEndpoints["ADD_USER_OBJECT"] = "add-user-object";
    ServerEndpoints["REMOVE_USER"] = "remove-user";
    ServerEndpoints["ADD_SERIAL_NUMBER_TO_USER"] = "add-serial-number-to-user";
    ServerEndpoints["ADD_ROBOT_NAME_TO_SERIAL_NUMBER"] = "add-robot-name-to-user";
    ServerEndpoints["SET_ANALYTICS_CONSENT"] = "set-analytics-consent";
    ServerEndpoints["SET_AUTOMATED_FAULT_REPORTING_CONSENT"] = "set-automated-fault-reporting-consent";
    ServerEndpoints["ADD_LOGIN_TOKEN_TO_USER"] = "add-login-token-to-user";
    ServerEndpoints["GET_LOGIN_TOKEN"] = "get-login-token";
    ServerEndpoints["GET_ALTERNATIVE_EMAILS_OF_REGISTERED_USER"] = "get-alternative-emails-of-registered-user";
    ServerEndpoints["ADD_ALTERNATIVE_EMAIL_TO_REGISTERED_USER"] = "add-alternative-email-to-registered-user";
    ServerEndpoints["REMOVE_ALTERNATIVE_EMAIL_FROM_REGISTERED_USER"] = "remove-alternative-email-from-registered-user";
    ServerEndpoints["ADD_REPORT_TO_USER"] = "add-report-to-user";
    ServerEndpoints["REMOVE_REPORT_FROM_USER"] = "remove-report-from-user";
    ServerEndpoints["GET_REPORT_FROM_USER"] = "get-report-from-user";
    ServerEndpoints["GET_PRIMARY_EMAIL_GIVEN_ALTERNATIVE_EMAIL"] = "get-primary-email-given-alternative-email";
    ServerEndpoints["ADD_ALTERNATIVE_TO_PRIMARY_ENTRY"] = "add-alternative-to-primary-entry";
    ServerEndpoints["REMOVE_ALTERNATIVE_TO_PRIMARY_ENTRY"] = "remove-alternative-to-primary-entry";
    ServerEndpoints["GET_ALTERNATIVE_EMAILS_GIVEN_PRIMARY_EMAIL"] = "get-alternative-emails-given-primary-email";
    ServerEndpoints["ADD_ALTERNATIVE_EMAIL_TO_PRIMARY_EMAIL"] = "add-alternative-email-to-primary-email";
    ServerEndpoints["REMOVE_ALTERNATIVE_EMAIL_FROM_PRIMARY_TO_ALTERNATIVE_MAP"] = "remove-alternative-email-from-primary-to-alternative-map";
    ServerEndpoints["REMOVE_PRIMARY_TO_ALTERNATIVE_ENTRY"] = "remove-primary-to-alternative-entry";
    ServerEndpoints["ZOHO_CREATE_TICKET"] = "zoho-create-ticket";
    ServerEndpoints["ZOHO_GET_TICKET"] = "zoho-get-ticket";
    ServerEndpoints["ZOHO_UPDATE_TICKET_STATUS"] = "zoho-update-ticket-status";
    ServerEndpoints["ZOHO_GET_TICKET_BY_SN"] = "zoho-get-ticket-by-sn";
    ServerEndpoints["ZOHO_ADD_COMMENT_TO_TICKET"] = "zoho-add-comment-to-ticket";
    ServerEndpoints["ZOHO_GET_COMMENTS_FROM_TICKET"] = "zoho-get-comments-from-ticket";
    ServerEndpoints["ZOHO_GET_COMMENT_FROM_TICKET"] = "zoho-get-comment-from-ticket";
    ServerEndpoints["ZOHO_DELETE_COMMENT_FROM_TICKET"] = "zoho-delete-comment-from-ticket";
})(ServerEndpoints || (ServerEndpoints = {}));
